// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add[data-v-9603e180] {\n  font-style: normal;\n}\n[data-v-9603e180] .el-message-box {\n  overflow: visible !important;\n}\n[data-v-9603e180] .el-form.el-form--label-right .el-col-24:last-of-type .el-form-item--small {\n  margin-bottom: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
